import React, { useState, useEffect, useMemo, useContext } from "react";
import { Helmet } from "react-helmet";
import axios from "../../../axios/index";

import { UserContext } from "../../Context/UserContextProvider";

import { useLocation, useHistory } from "react-router-dom";

// styles
import styles from "./UserFilesDetail.module.css";
import Dstyles from "../../Dashboard/DashboardFileManagement/DashboardFileManagement.module.css";

// components
import HomeNavbar from "../HomeNavbar/HomeNavbar";
import HomeModal from "./../HomeModal/HomeModal";
import Footer from "../Footer/Footer";
// import ImagesSlider from './ImagesSlider';
import CardSlider from "../../Dashboard/DashboardFileManagement/CardDetail/CardSlider";
import UserFilesDetailFacilities from "./UserFilesDetailFacilities/UserFilesDetailFacilities";
import UserFilesDetailFacilitiesSimilarFiles from "./UserFilesDetailFacilitiesSimilarFiles/UserFilesDetailFacilitiesSimilarFiles";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// images
import eveIcon from "../../../assets/img/DashboardICons/EyeIcon.svg";
import arrowIcon from "../../../assets/img/DashboardICons/ArrowRounded.svg";
import { useParams } from "react-router-dom/cjs/react-router-dom";
// import userTestImg from "../../../assets/img/DashboardICons/userProfileAccount.png"

const UserFilesDetail = props => {
  const { userToken } = useContext(UserContext);
  const { state } = useLocation();
  const { id } = useParams();
  const history = useHistory();
  const e2p = s => s?.toString()?.replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d]);
  const [showModal, setShowModal] = useState(false);
  const [fileData, setFileData] = useState([]);
  const [chartData, setChartData] = useState({
    chartData1: null,
    chartData2: null,
  });
  const [addedFacilitiesID, setAddedFacilitiesID] = useState([]);
  const [facilitiData, setFacilitiData] = useState();
  const [addedFacilities, setAddedFacilities] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [limitedFields, setLimitedFields] = useState([]);
  const [cardData, setCardData] = useState();
  const [categories, setCategories] = useState([]);
  const [dealType, setDealType] = useState();

  useMemo(() => fileData, [fileData]);

  const shopCategories = [304, 280];
  const hotelCategories = [278, 291];
  const gasStationCategories = [309, 316];
  const landCategories = [273, 277, 281, 284, 287, 302, 305, 308, 312, 315, 517];
  const industrialCategories = [311, 312, 313, 314, 318, 319, 320, 321];

  function getParentCategory(categoryId) {
    let parentId = 0;
    categories.forEach(category => {
      if (category.id == categoryId) {
        parentId = category.parentId;
      }
    });

    return parentId;
  }

  function getFieldsBasedOnType(fileData) {
    let fileCategory = fileData.categoryId;
    if (
      shopCategories.includes(getParentCategory(fileCategory)) ||
      gasStationCategories.includes(getParentCategory(fileCategory)) ||
      hotelCategories.includes(getParentCategory(fileCategory))
    ) {
      return 1;
    }
    if (landCategories.includes(getParentCategory(fileCategory))) {
      return 1;
    }
    if (industrialCategories.includes(getParentCategory(fileCategory))) {
      return 2;
    }
    return 2;
  }

  useEffect(() => {
    const getData = async () => {
      try {
        if (state?.state?.slug != undefined) {
          var getApiData = await axios.get(`Estate/bySlug/${state?.state?.slug || id}`, { headers: { authorization: "Bearer " + userToken } });
        } else {
          try {
            var getApiData = await axios.get(`Estate/${id}`, { headers: { authorization: "Bearer " + userToken } });
          } catch (er) {
            var getApiData = await axios.get(`Estate/bySlug/${id}`, { headers: { authorization: "Bearer " + userToken } });
          }
        }

        const detailData = await getApiData.data.data;
        const seoData = getApiData.data.data?.seoData;

        const getApiDataFacilities = await axios.get(
          `Specification/GetList?categoryId=${getApiData.data.data.categoryId}&subCategoryId=${getApiData.data.data.subCategoryId}`,
          { headers: { authorization: "Bearer " + userToken } }
        );
        setFileData(detailData);
        if (detailData) {
          const status = (await detailData.rentPrice) === null || detailData.rentPrice === 0 ? 1 : 3;
          const status2 = (await detailData.rentPrice) === null || detailData.rentPrice === 0 ? 2 : 4;
          const [chartData1Promise, chartData2Promise] = await Promise.all([
            axios.get(`Estate/PriceChanges?estateId=${state?.state?.id || detailData.id}&priceType=${status}`, {
              headers: { authorization: "Bearer " + userToken },
            }),
            axios.get(`Estate/PriceChanges?estateId=${state?.state?.id || detailData.id}&priceType=${status2}`, {
              headers: { authorization: "Bearer " + userToken },
            }),
          ]);
          if (chartData1Promise.data.data) setChartData(prevState => ({ ...prevState, chartData1: chartData1Promise.data.data }));
          if (chartData2Promise.data.data) setChartData(prevState => ({ ...prevState, chartData2: chartData2Promise.data.data }));
        }
        // console.log(getApiData.data.data)
        const filteredFacilities = getApiData.data.data.facilities.split(",") ?? [];
        setAddedFacilities(filteredFacilities);
        setFacilitiData(getApiDataFacilities.data.data);
        const filterdObjects = getApiDataFacilities.data.data.filter(obj => {
          return filteredFacilities.includes(obj.title);
        });
        setAddedFacilitiesID(filterdObjects.map(item => item.id));

        const getLimitations = await axios.get(`Estate/EstateLimitFields?estateId=${state?.state?.id || detailData.id}`, {
          headers: { authorization: "Bearer " + userToken },
        });
        if (getLimitations.data.data !== null) {
          const limitName = getLimitations.data.data.fileItems.map(item => item.fieldName);
          setLimitedFields(limitName);
        }
        // console.log(categories?.find(c => c.id == detailData.categoryId)?.dealType);

        const dealType = categories?.find(c => c.id == detailData.categoryId)?.dealType;

        setDealType(detailData.rentPrice ? 0 : 1);

        // console.log(detailData.categoryId, dealType, categories);

        // bottom sliders API
        const getSalesData = await axios.get(
          `Home/GetProducts?search=${detailData.address.zone}&EstateType=${getFieldsBasedOnType(detailData)}&DealType=${detailData.rentPrice ? 1 : 0}`,
          {
            headers: { authorization: "Bearer " + userToken },
          }
        );
        const salesData = getSalesData.data.data.data;
        setCardData(salesData.filter(item => item.totalPrice !== 0 || item.rentPrice != 0));

        setIsLoading(false);
      } catch (ex) {
        //window.location.href = "/"
      }
    };
    getData();

    return () => {};
  }, [state, userToken, categories]);

  function loginToChat() {
    history.push("/ورود", {
      estateId: fileData.id,
      subject: fileData.slug,
      resiverId: fileData.userId,
    });
  }

  useEffect(() => {
    axios.get("Category").then(res => {
      setCategories(res.data.data);
    });
  }, []);

  const data = {
    responsive: true,
    labels: chartData?.chartData2?.map(item => item.pChangeDate),
    datasets: [
      {
        label: fileData?.rentPrice === null || fileData?.rentPrice === 0 ? "تغییرات قیمت کل" : "تغییرات رهن",
        data: chartData?.chartData1?.map(item => item.price),
        borderColor: "#127442",
        backgroundColor: "#127442",
      },
      {
        label: fileData?.rentPrice === null || fileData?.rentPrice === 0 ? "تغییرات هر متر" : "تغییرات اجاره",
        data: chartData?.chartData2?.map(item => item.price),
        borderColor: "rgb(53, 162, 235)",
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
    ],
    options: {
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
            },
          },
        ],
      },
    },
  };

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 768px)");

    setIsMobile(mediaQuery.matches);

    const handleResize = e => {
      setIsMobile(e.matches);
    };

    mediaQuery.addEventListener("change", handleResize);

    return () => {
      mediaQuery.removeEventListener("change", handleResize);
    };
  }, []);

  console.log(categories?.find(c => c.id == fileData.categoryId)?.dealType);

  return (
    <>
      <Helmet>
        <title>{fileData?.title?.toString() || "Azar Melk"} | آذر ملک</title>
      </Helmet>

      <ToastContainer
        position="top-right"
        autoClose={9000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />

      {isLoading ? (
        <></>
      ) : (
        <div className="d-flex justify-content-center align-items-center vw-100">
          <div className="w-100 text-center ms-0 p-0" style={{ background: "#FFFFFF" }}>
            <HomeNavbar navSale={fileData?.totalPrice !== 0 && "true"} navRent={fileData?.rentPrice !== 0 && "true"} />

            <div className="container py-3 px-0">
              <div
                className="w-100 d-flex justify-content-md-between justify-content-center flex-wrap flex-md-row flex-column align-items-center mt-3 px-2"
                dir="rtl">
                {limitedFields?.find(item => item === "Title") ? (
                  <></>
                ) : (
                  <div className="d-flex align-items-center justify-content-center mt-2">
                    <div
                      onClick={() => {
                        console.log("first", history);
                        history.goBack();
                      }}>
                      {" "}
                      <img className="ms-2" src={arrowIcon} alt="icon" style={{ cursor: "pointer" }} />
                    </div>
                    <div className={styles.title}>{e2p(fileData?.title?.toString())}</div>
                  </div>
                )}

                {limitedFields?.find(item => item === "Visit") ? (
                  <></>
                ) : (
                  <div className={`d-flex align-items-center justify-content-evenly py-2 ${styles.card_view_info}`}>
                    <img src={eveIcon} alt="icon" />
                    <div className={styles.card_view_number}>{e2p(fileData.visit?.toString())} بازدید</div>
                  </div>
                )}
              </div>
            </div>

            <div className="container">
              <CardSlider images={fileData?.images.filter((val, index) => index != 0)} image={fileData?.imageUrl} wFull />
            </div>

            <div className="container py-3 px-0">
              <div className="w-100 d-flex justify-content-md-between justify-content-center align-items-start flex-wrap" dir="rtl">
                {isMobile ? (
                  <></>
                ) : (
                  <UserFilesDetailFacilities
                    data={fileData}
                    limitedFields={limitedFields}
                    chartData={data}
                    addedFacilities={addedFacilities}
                    setAddedFacilities={setAddedFacilities}
                    facilitiData={facilitiData}
                    itemID={facilitiData}
                    addedFacilitiesID={addedFacilitiesID}
                    setAddedFacilitiesID={setAddedFacilitiesID}
                  />
                )}
                <div className={`d-flex flex-column align-items-center justify-content-start p-3 flex-wrap ${styles.consultant_box_container}`}>
                  <div className="w-100 d-flex align-items-center justify-content-start">
                    <div className={styles.consultant_profile}>
                      {/* fileData */}

                      <img src={`https://backdev.azrmelk.com/images/users/avatar/${fileData?.ownerDetail.avatar}`} alt="user-profile" />
                    </div>
                    <div className="d-flex flex-column align-items-start justify-content-center me-2">
                      <div className={styles.text_title_sm}>{fileData?.ownerDetail.fullName}</div>
                      <div className={styles.text_gray}>{fileData?.ownerDetail.responsibility}</div>
                    </div>
                  </div>
                  {categories?.find(c => c.id == fileData.categoryId)?.dealType != 1 ? (
                    <>
                      {limitedFields?.find(item => item === "TotalPrice") ? (
                        <></>
                      ) : (
                        <div className="w-100 d-flex align-items-center justify-content-start mt-3 mb-2">
                          <div className={`ms-2 ${styles.text_gray}`}>قیمت کل:</div>
                          <div className={styles.text_title_md}>{e2p(fileData?.totalPrice?.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"))}</div>
                          <span className={`me-1 ${styles.text_gray}`}>تومان</span>
                        </div>
                      )}
                      <div className="w-100 d-flex align-items-center justify-content-start mt-2 mb-3">
                        <div className={`ms-2 ${styles.text_gray}`}>شناسه فایل:</div>
                        <div className={`pointer ${styles.file_code}`} onClick={() => handleCopyClick(fileData?.fileCode?.match(/\d+/)[0])}>
                          {fileData?.fileCode?.match(/\d+/)[0]}
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      {props.limitedFields?.find(item => item === "MortgagePrice") ? (
                        <></>
                      ) : (
                        <div className="w-100 d-flex align-items-center justify-content-start mt-3 mb-2">
                          <div className={`ms-2 ${styles.text_gray}`}>رهن:</div>
                          <div className={styles.text_title_md}>{e2p(fileData?.mortgagePrice?.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"))}</div>
                          <span className={`me-1 ${styles.text_gray}`}>تومان</span>
                        </div>
                      )}

                      {props.limitedFields?.find(item => item === "RentPrice") ? (
                        <></>
                      ) : (
                        <div className="w-100 d-flex align-items-center justify-content-start mt-2 mb-3">
                          <div className={`ms-2 ${styles.text_gray}`}>اجاره ماهانه:</div>
                          <div className={styles.text_title_md}>{e2p(fileData?.rentPrice?.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"))}</div>
                          <span className={`me-1 ${styles.text_gray}`}>تومان</span>
                        </div>
                      )}

                      <div className="w-100 d-flex align-items-center justify-content-start mt-2 mb-3">
                        <div className={`ms-2 ${styles.text_gray}`}>شناسه فایل:</div>
                        <div className={`pointer ${styles.file_code}`} onClick={() => handleCopyClick(fileData?.fileCode?.match(/\d+/)[0])}>
                          {fileData?.fileCode?.match(/\d+/)[0]}
                        </div>
                      </div>
                    </>
                  )}
                  <div className="w-100 d-flex align-items-center justify-content-center mt-3 mb-2">
                    <a
                      className={`w-100 d-flex align-items-center justify-content-center ${styles.call_btn}`}
                      href={`tel:${fileData?.ownerDetail.phoneNumber}`}>
                      تماس با مشاور
                    </a>
                  </div>
                  <div className="w-100 d-flex align-items-center justify-content-between mt-3">
                    {userToken == "" ? (
                      <button
                        className={`w-100 d-flex align-items-center justify-content-center ms-2 ${styles.btn_bg_white}`}
                        onClick={() => setShowModal(true)}>
                        <svg className="ms-1" width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M0.585786 0.585786C0.960859 0.210714 1.46957 0 2 0H8C8.53043 0 9.03914 0.210714 9.41421 0.585786C9.78929 0.960859 10 1.46957 10 2V13.5C10 13.6969 9.88444 13.8755 9.70483 13.9561C9.52521 14.0368 9.31498 14.0045 9.16782 13.8737L5 10.169L0.832182 13.8737C0.68502 14.0045 0.474788 14.0368 0.295172 13.9561C0.115556 13.8755 0 13.6969 0 13.5V2C0 1.46957 0.210714 0.960859 0.585786 0.585786ZM2 1C1.73478 1 1.48043 1.10536 1.29289 1.29289C1.10536 1.48043 1 1.73478 1 2V12.3866L4.66782 9.1263C4.85726 8.9579 5.14274 8.9579 5.33218 9.1263L9 12.3866V2C9 1.73478 8.89464 1.48043 8.70711 1.29289C8.51957 1.10536 8.26522 1 8 1H2Z"
                            fill="#21409A"
                          />
                        </svg>
                        ذخیره
                      </button>
                    ) : (
                      <button
                        onClick={fileData?.isSavedByUser ? removeSaveHandler : saveCardHandler}
                        className={`w-100 d-flex align-items-center justify-content-center ms-2 ${styles.btn_bg_white}`}>
                        {fileData?.isSavedByUser ? (
                          <svg xmlns="http://www.w3.org/2000/svg" className="ms-1 pointer" width="13" height="14" fill="#21409A" viewBox="0 0 16 16">
                            <path d="M2 2v13.5a.5.5 0 0 0 .74.439L8 13.069l5.26 2.87A.5.5 0 0 0 14 15.5V2a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2z" />
                          </svg>
                        ) : (
                          <svg xmlns="http://www.w3.org/2000/svg" className="ms-1 pointer" width="13" height="14" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5V2zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1H4z" />
                          </svg>
                        )}
                        ذخیره
                      </button>
                    )}
                    {userToken == "" || userToken == undefined ? (
                      <button onClick={loginToChat} className={`w-100 d-flex align-items-center justify-content-center me-2 ${styles.btn_bg_white}`}>
                        <svg className="ms-1" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M6.99423 1C3.66228 1 0.989502 3.63343 0.99954 6.85282L0.999543 6.85361V6.85439C0.999503 7.97429 1.32683 9.06967 1.94111 10.0058C1.9762 10.0538 2.00902 10.1033 2.03947 10.1543L2.04189 10.1584L2.04423 10.1625C2.09353 10.2487 2.15198 10.3648 2.19227 10.4931C2.22914 10.6105 2.2716 10.8019 2.21611 11.0061L2.21582 11.0072L1.69939 12.8752L3.48527 12.2307C3.66283 12.1576 3.85309 12.1203 4.04517 12.1209C4.04549 12.1209 4.04581 12.1209 4.04613 12.1209L4.04423 12.6209L4.04479 12.1209C4.04492 12.1209 4.04504 12.1209 4.04517 12.1209C4.225 12.1212 4.40326 12.1544 4.57113 12.2189L4.57149 12.2191L4.57185 12.2192C4.67321 12.2583 5.07695 12.4083 5.47618 12.5201C5.86865 12.6299 6.5934 12.7631 7.1061 12.7631C10.4214 12.7631 12.9995 10.1012 12.9995 6.85924L13.4995 6.85906H12.9995C12.9994 6.45689 12.9568 6.05585 12.8725 5.66261L12.8724 5.66209L12.8723 5.66156C12.31 3.01064 9.89776 1 6.99423 1ZM-0.00045737 6.85515C-0.0118596 3.05927 3.13269 0 6.99423 0C10.3642 0 13.1886 2.33525 13.8504 5.45334C13.9494 5.91531 13.9994 6.38643 13.9995 6.85889V6.85906C13.9995 10.6426 10.9845 13.7631 7.1061 13.7631C6.47506 13.7631 5.65606 13.6088 5.20666 13.4831C4.76457 13.3593 4.32823 13.1971 4.21205 13.1522C4.1583 13.1316 4.10124 13.121 4.04367 13.1209L4.043 13.1209L4.04233 13.1209C3.98017 13.1207 3.9186 13.1331 3.86136 13.1573L3.84889 13.1626L1.72827 13.9279C1.64023 13.964 1.54746 13.9874 1.45276 13.9973L1.42609 14.0001L1.39928 14C1.29344 13.9997 1.18872 13.9784 1.09119 13.9373C0.993649 13.8962 0.90523 13.8362 0.831055 13.7607C0.756879 13.6852 0.69842 13.5957 0.659065 13.4975C0.61971 13.3992 0.600239 13.2942 0.601783 13.1883L0.602002 13.1733L0.603124 13.1583C0.608243 13.0899 0.62042 13.0222 0.639457 12.9563L1.23788 10.7917C1.22697 10.7574 1.20614 10.7118 1.17848 10.663C1.16343 10.6381 1.14719 10.6139 1.1298 10.5905L1.12125 10.5791L1.11337 10.5671C0.386917 9.46542 -0.000348323 8.1748 -0.00045737 6.85515Z"
                            fill="#21409A"
                          />
                        </svg>
                        چت با مشاور
                      </button>
                    ) : (
                      <button onClick={createChat} className={`w-100 d-flex align-items-center justify-content-center me-2 ${styles.btn_bg_white}`}>
                        <svg className="ms-1" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M6.99423 1C3.66228 1 0.989502 3.63343 0.99954 6.85282L0.999543 6.85361V6.85439C0.999503 7.97429 1.32683 9.06967 1.94111 10.0058C1.9762 10.0538 2.00902 10.1033 2.03947 10.1543L2.04189 10.1584L2.04423 10.1625C2.09353 10.2487 2.15198 10.3648 2.19227 10.4931C2.22914 10.6105 2.2716 10.8019 2.21611 11.0061L2.21582 11.0072L1.69939 12.8752L3.48527 12.2307C3.66283 12.1576 3.85309 12.1203 4.04517 12.1209C4.04549 12.1209 4.04581 12.1209 4.04613 12.1209L4.04423 12.6209L4.04479 12.1209C4.04492 12.1209 4.04504 12.1209 4.04517 12.1209C4.225 12.1212 4.40326 12.1544 4.57113 12.2189L4.57149 12.2191L4.57185 12.2192C4.67321 12.2583 5.07695 12.4083 5.47618 12.5201C5.86865 12.6299 6.5934 12.7631 7.1061 12.7631C10.4214 12.7631 12.9995 10.1012 12.9995 6.85924L13.4995 6.85906H12.9995C12.9994 6.45689 12.9568 6.05585 12.8725 5.66261L12.8724 5.66209L12.8723 5.66156C12.31 3.01064 9.89776 1 6.99423 1ZM-0.00045737 6.85515C-0.0118596 3.05927 3.13269 0 6.99423 0C10.3642 0 13.1886 2.33525 13.8504 5.45334C13.9494 5.91531 13.9994 6.38643 13.9995 6.85889V6.85906C13.9995 10.6426 10.9845 13.7631 7.1061 13.7631C6.47506 13.7631 5.65606 13.6088 5.20666 13.4831C4.76457 13.3593 4.32823 13.1971 4.21205 13.1522C4.1583 13.1316 4.10124 13.121 4.04367 13.1209L4.043 13.1209L4.04233 13.1209C3.98017 13.1207 3.9186 13.1331 3.86136 13.1573L3.84889 13.1626L1.72827 13.9279C1.64023 13.964 1.54746 13.9874 1.45276 13.9973L1.42609 14.0001L1.39928 14C1.29344 13.9997 1.18872 13.9784 1.09119 13.9373C0.993649 13.8962 0.90523 13.8362 0.831055 13.7607C0.756879 13.6852 0.69842 13.5957 0.659065 13.4975C0.61971 13.3992 0.600239 13.2942 0.601783 13.1883L0.602002 13.1733L0.603124 13.1583C0.608243 13.0899 0.62042 13.0222 0.639457 12.9563L1.23788 10.7917C1.22697 10.7574 1.20614 10.7118 1.17848 10.663C1.16343 10.6381 1.14719 10.6139 1.1298 10.5905L1.12125 10.5791L1.11337 10.5671C0.386917 9.46542 -0.000348323 8.1748 -0.00045737 6.85515Z"
                            fill="#21409A"
                          />
                        </svg>
                        چت با مشاور
                      </button>
                    )}
                  </div>
                </div>
                {!isMobile ? (
                  <></>
                ) : (
                  <UserFilesDetailFacilities
                    data={fileData}
                    limitedFields={limitedFields}
                    chartData={data}
                    addedFacilities={addedFacilities}
                    setAddedFacilities={setAddedFacilities}
                    facilitiData={facilitiData}
                    itemID={facilitiData}
                    addedFacilitiesID={addedFacilitiesID}
                    setAddedFacilitiesID={setAddedFacilitiesID}
                    dealType={dealType}
                  />
                )}
              </div>
            </div>

            <div className="container py-3 px-0">
              {/* <div className="container-fluid"> */}
              <div
                className="w-100 d-flex justify-content-md-between justify-content-center flex-wrap flex-md-row flex-column align-items-center mt-3 px-4"
                dir="rtl">
                <UserFilesDetailFacilitiesSimilarFiles dealType={dealType} cardData={cardData} isMultiple={fileData.isAnyChild} multipleID={fileData.id} />
              </div>
            </div>

            <Footer />
          </div>
        </div>
      )}
    </>
  );

  function notify(text, type) {
    if (type === "success") {
      toast.success(text, {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(text, {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }

  function backHandler() {
    if (state.state?.meteragePrice == "0") {
      const data = {
        pageNumber: state.pageNumber,
        query: state.query,
      };
      history.push("/رهن-و-اجاره", data);
    } else {
      const data = {
        pageNumber: state.pageNumber,
        query: state.query,
      };
      history.push("/خرید", data);
    }
  }

  function handleCopyClick(number) {
    navigator.clipboard.writeText(number);
    notify("کد فایل کپی شد", "success");
  }

  async function createChat() {
    notify("درحال ایجاد چت", "success");
    try {
      var data = new FormData();
      data.append("RecieverId", fileData.userId);
      data.append("EstateId", fileData.id);
      data.append("Subject", fileData.slug);
      const apiData = await axios.post("Messages/CreateMessage", data, {
        headers: { authorization: "Bearer " + userToken },
      });
      // if (apiData.data.isSuccess) {
      history.push("/chats");
      // }
    } catch (error) {
      notify("خطای سرور", "error");
    }
  }

  async function saveCardHandler() {
    notify("درحال ذخیره فایل", "success");
    try {
      var saveData = new FormData();
      saveData.append("estateId", state.state.id);

      const addSave = await axios.post(`Estate/SaveEstate?estateId=${state.state.id}`, saveData, {
        headers: { authorization: "Bearer " + userToken },
      });
      // console.log(addSave.data)
      notify("فایل با موفقیت ذخیره شد", "success");
      if (addSave.data.isSuccess === true) {
        // setSaveCard(true)
        window.location.reload(false);
      }
    } catch (error) {
      notify("خطای سرور", "error");
    }
  }

  async function removeSaveHandler() {
    notify("درحال حذف ذخیره فایل", "success");
    try {
      var saveData = new FormData();
      saveData.append("estateId", state.state.id);

      const removeSave = await axios.post(`Estate/RemoveFromSaveList?estateId=${state.state.id}`, saveData, {
        headers: { authorization: "Bearer " + userToken },
      });
      // console.log(removeSave.data)
      if (removeSave.data.isSuccess === true) {
        // setSaveCard(false)
        window.location.reload(false);
      }
    } catch (error) {
      notify("خطای سرور", "error");
    }
  }
};

export default React.memo(UserFilesDetail);
